import PropTypes from 'prop-types'
import React from 'react'

import { Button } from '../NarusMaterial/Button'

import { makeAutobindedInput } from './FormBuilder'
import { QuestionRadioButtonInput } from './QuestionRadioButton'
import { TextInput } from './Text'

class RadioRequiredText_ extends React.Component {
  // required prop should evaluate the values passed in and return a bool

  render () {
    const {
      question,
      radioButtons,
      fieldName,
      fieldName2,
      textLabel,
      required
    } = this.props
    return (
      <div className='row bottom-xs'>
        <div className='col-xs-10'>
          <QuestionRadioButtonInput
            question={question}
            name={fieldName}
            radioButtons={radioButtons}
            noClear
          />
        </div>
        <div className='col-xs-2'>
          <Button
            grey
            label='Clear'
            onClick={this.handleClick}
          />
        </div>
        <div className='col-xs-12'>
          <TextInput
            label={textLabel}
            name={fieldName2}
            required={required}
          />
        </div>
      </div>
    )
  }
}

RadioRequiredText_.propsTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldName2: PropTypes.string.isRequired,
  textLabel: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  radioButtons: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired
}

export const RadioRequiredText = makeAutobindedInput(RadioRequiredText_)
